import { UserActionsMetadata } from 'modules/campaigns/lib/components';
import { CampaignEditorView } from '../../types';
import { useCampaignContext, useEditorContext } from '../../context';
import { CampaignEditableContent, CampaignSummaryContent } from '../CampaignCard';
import { UnsavedChangesPrompt } from '../UnsavedChangesPrompt';
import { PrimaryContentWrapper } from './PrimaryContent.styles';
import { PrimaryContentProvider } from './PrimaryContentProvider';

const CAMPAIGN_EDITOR_VIEW_CONTENT_MAPPER = {
  [CampaignEditorView.Edit]: CampaignEditableContent,
  [CampaignEditorView.Summary]: CampaignSummaryContent,
};

export const PrimaryContent = () => {
  const { campaignEditorView } = useEditorContext();
  const {
    campaign: { createdAt, creatorUser },
  } = useCampaignContext();

  const CampaignViewContent = CAMPAIGN_EDITOR_VIEW_CONTENT_MAPPER[campaignEditorView];

  return (
    <PrimaryContentProvider>
      <UnsavedChangesPrompt />
      <PrimaryContentWrapper>
        <CampaignViewContent />
        <UserActionsMetadata createdDate={createdAt} creator={creatorUser} />
      </PrimaryContentWrapper>
    </PrimaryContentProvider>
  );
};
